import React from 'react';

import { Field } from 'formik';

import SearchPortsDropdown from './search-ports-dropdown/components/SearchPortsDropdown';
import Input from './Input';

export default function FlexibleInput(props) {
  const {
    isTextInput,
    inputName,
    dropdownName,
    label,
    dropdownID,
    placeholder,
    getSpecificValue,
    ...rest
  } = props;

  return (
    <>
      {isTextInput ? (
        <Input
          name={inputName}
          label={label}
          placeholder={placeholder}
          {...rest}
        />
      ) : (
        <>
          <SearchPortsDropdown
            label={label}
            name={dropdownName || inputName}
            dropdownID={dropdownID}
            placeholder={placeholder}
            getSpecificValue={getSpecificValue}
            {...rest}
          />
          <Field name={dropdownName || inputName} type="hidden" />
        </>
      )}
    </>
  );
}
